<div class="img-container">
    <!--<div popup-host class="dynamic-popup" (mouseenter)="onSkillMouseEnter($event, {'articleId': articleId})"></div>-->

    <div class="article-img"
         [style.height]="height ? height : 38">

        <img src="{{getImgUrl()}}" alt="Article picture"
             [attr.height]="height ? height : 38" />
    </div>
</div>
